import requests from "./httpServices";

const ReviewServices = {
  getShowingReviews() {
    return requests.get("/review/");
  },

  getShowingReviewbyId(id) {
    return requests.get(`/review/${id}`);
  },
  getShowingReviewbyProductId(id) {
    return requests.get(`/review/product/${id}`);
  },

  addReview(body) {
    return requests.post("/review/add", body);
  },

  updateReviewbyId(id) {
    return requests.put(`/review/${id}`);
  },

  deleteReviewbyId(id) {
    return requests.delete(`/review/${id}`);
  },

  deleteReviewbyProductId(id) {
    return requests.delete(`/review/product/${id}`);
  },
};

export default ReviewServices;
